import { render, staticRenderFns } from "./MotifFinder.vue?vue&type=template&id=2f64075a&scoped=true"
import script from "./MotifFinder.vue?vue&type=script&lang=js"
export * from "./MotifFinder.vue?vue&type=script&lang=js"
import style0 from "./MotifFinder.vue?vue&type=style&index=0&id=2f64075a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64075a",
  null
  
)

export default component.exports